var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIneligible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ineligible") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Copy-4",
    transform: "translate(-278.000000, -618.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(221.000000, 187.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(39.000000, 419.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ineligible",
    transform: "translate(18.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#A81A00",
    strokeWidth: 2,
    cx: 12,
    cy: 12.1764706,
    rx: 11,
    ry: 11.1764706
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6575782,6.51813933 C17.6579812,6.51854242 17.6583838,6.51894582 17.6587862,6.51934951 C18.1137732,6.97580841 18.1131225,7.71451476 17.657332,8.17017137 L13.6486002,12.1768737 L17.657332,16.1835752 C18.080566,16.6066849 18.1113581,17.2738528 17.7493096,17.7324703 L17.6587862,17.834397 C17.6583838,17.8348007 17.6579812,17.8352041 17.6575782,17.8356072 C17.2027855,18.2905335 16.4653125,18.2906418 16.0103861,17.8358491 L16.0103861,17.8358491 L11.9996002,13.8258737 L7.98881519,17.8358491 C7.53388887,18.2906418 6.79641588,18.2905335 6.34162315,17.8356072 C6.34122017,17.8352041 6.34081749,17.8348007 6.3404151,17.834397 C5.88542813,17.3779381 5.88607885,16.6392318 6.3418693,16.1835752 L10.3496002,12.1768737 L6.3418693,8.17017137 C5.91863531,7.74706166 5.88784323,7.07989376 6.24989176,6.62127623 L6.3404151,6.51934951 C6.34081749,6.51894582 6.34122017,6.51854242 6.34162315,6.51813933 C6.79641588,6.06321301 7.53388887,6.06310472 7.98881519,6.51789744 L7.98881519,6.51789744 L11.9996002,10.5268737 L16.0103861,6.51789744 C16.4653125,6.06310472 17.2027855,6.06321301 17.6575782,6.51813933 Z",
    id: "Combined-Shape",
    fill: "#A3230C"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIneligible);
export default __webpack_public_path__ + "static/media/ineligible.0af34a957c42311498403149fd706c1b.svg";
export { ForwardRef as ReactComponent };